import { Button, EmptyState } from "@closer/ui";

import type { UiState } from "../lib/uiState";

export interface StateViewProps {
  state: UiState;
  /**
   * Yeniden deneme eylemi. ⚠ Düğme YALNIZ `state.retry` doğruysa çiziliyor — kartın
   * runtime koşulu idempotent olmayan komutun körlemesine tekrarlanmasını yasaklıyor ve
   * o kararı `resolveErrorState` veriyor, çağıran değil.
   */
  onRetry?: () => void;
}

/**
 * Bir durumun kanonik sunumu (CLOS-106 `[067]`).
 *
 * Bileşen hiçbir KARAR vermiyor: ne metni seçiyor, ne yeniden denemenin güvenli olup
 * olmadığına bakıyor. İkisi de `lib/uiState.ts`'te — tek güvenlik kapısı. Burada karar
 * verilseydi kural iki yere dağılır ve biri gün gelir gevşerdi.
 */
export function StateView({ state, onRetry }: StateViewProps) {
  return (
    <EmptyState
      title={state.title}
      description={state.description}
      action={
        state.retry && onRetry ? (
          <Button size="sm" variant="secondary" onClick={onRetry}>
            Yeniden dene
          </Button>
        ) : undefined
      }
    />
  );
}
